module.exports = fox._r("fonts/museosanscyrl_2-webfont.woff", __webpack_public_path__ + "fonts/381VNrR.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl_2-webfont.woff
// module id = 584
// module chunks = 2